import React, { useState } from "react";
import Header from "../../component/Header";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import api from "../../Services/api";
import { useSwal } from "../../component/sweetalert";
export default function AddCareer() {
  const [formData, setFormData] = useState({
    heading: "",
    content: "",
  });
  const alert = useSwal();
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const [loading, setLoading] = useState(false);

  const handleChangereactuill = (value) => {
    setFormData((prev) => ({
      ...prev,
      content: value, // Directly update 'content' without event.target
    }));
  };
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.heading || !formData.content) {
      return alert("error", "All fields are required.");
    }

    try {
      setLoading(true);
      await api.post("/insertCareer", formData);

      await alert("success", "News added successfully!");
      // Clear the form after successful submission
      setFormData({ heading: "", content: "" });
    } catch (error) {
      console.error("❌ Error inserting career:", error);
      alert("error", "Something went wrong. Please try again.");
      }finally {
        setLoading(false);
      }
  };

  return (
    <section className="dashboardpage">
      <Header pageTitle="Add New Job Post Details" backTo="/career" />
      <div className="pageLeftspace">
        {/* Back to Events Link */}
        <div className="d-flex justify-content-start col-xl-6 col-12">
        <form className="form-fields d-flex" onSubmit={handleSubmit}>
          <div className="grid-container user">
            {/* Heading Input */}
            <div className="input-container">
              <input
                type="text"
                id="heading"
                name="heading"
                placeholder="Enter Job Title"
                value={formData.heading}
                onChange={handleChange}
                required
              />
              {/* <label htmlFor="heading">Heading</label> */}
              <span className="underline"></span>
            </div>

            {/* Content Input */}

            <div className="input-container description-container">
              <ReactQuill
                value={formData.content}
                onChange={handleChangereactuill}
                theme="snow"
                placeholder=" "
                className="react-quill-wrapper"
              />
            </div>

        
            <button className="btn btn-purpal" type="submit" disabled={loading}>
  {loading ? "Submitting..." : "Submit"}
</button>
          </div>

          {/* Submit Button */}
        </form>
        </div>
      </div>
    </section>
  );
}
